import { render, staticRenderFns } from "./AppCustom.vue?vue&type=template&id=306f479e&scoped=true&"
import script from "./AppCustom.vue?vue&type=script&lang=js&"
export * from "./AppCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f479e",
  null
  
)

export default component.exports